import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Element from 'element-ui'
import './styles/element-variables.scss'
import enlang from 'element-ui/lib/locale/lang/en'
// import { Message } from 'element-ui'

import './permission'

import filters from './filters'

const lang = 'en'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: lang, // set locale
    messages: { // set locale messages
        en: require('./languages/en.js')
    },
})

// global css
import './styles/index.scss'

Vue.use(Element, { 
    size: 'small', 
    // zIndex: 3000,
    locale: enlang
});

for (let key in filters) {
    Vue.filter(key, filters[key]);
}

import './icons/index.js'
import SvgIcon from '@/components/SvgIcon.vue'
Vue.component('svg-icon', SvgIcon);

import Tooltip from '@/components/Tooltip.vue'
// eslint-disable-next-line
Vue.component('tooltip', Tooltip);


import '@/directive/cleave.js'

function rewirteLog() {
    console.log = (function (log) {
        return process.env.NODE_ENV === 'development' || localStorage.getItem('debug') == '123' ? log : function() {}
    }(console.log))
}
rewirteLog()

import '@/utils/checkNetwork'

Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
    beforeCreate() {
        Vue.prototype.$bus = this
    },
}).$mount('#app')
